import { isJson, maskEmail } from "helpers";

export const getUserProfile = () => {
  let userProfile = window.localStorage.getItem("wads_userProfile")
    ? window.localStorage.getItem("wads_userProfile")
    : null;
  if (isJson(userProfile)) {
    userProfile = JSON.parse(userProfile);
    if (userProfile?.value) {
      return userProfile.value;
    }
  }
  return userProfile;
};

export const setUserLocalStorage = (user, response) => {
  let suscription =
    response.user != null
      ? response.user.data.subscriptions.map((sus) => {
          return sus.pId;
        })
      : "";
  let userStorage = {
    uid: response.sub,
    name: response.hasOwnProperty("https://clarin.com/etiquetaUsuario")
      ? response["https://clarin.com/etiquetaUsuario"]
      : response.name,
    email: response.email,
    genero: response.hasOwnProperty("https://clarin.com/genero")
      ? response["https://clarin.com/genero"]
      : "",
    picture: response.picture,
    fechaNacimiento: response.hasOwnProperty(
      "https://clarin.com/fechaNacimiento"
    )
      ? response["https://clarin.com/fechaNacimiento"]
      : "",
    apodo: response.nickname,
    estado: "ACTIVO",
    siteUID: true,
    subscriptionStatus: suscription.includes("CLARIN_C") || suscription.includes("CLARIN_D") || suscription.includes("CLA_OLE") ? "subscribed" : '',
    subscriptionProducts: suscription,
    id: response.sub,
    sessionId: response.user != null ? response.user._id : "",
    sessionStatus: response.user != null ? "valid" : "",
    userSubscriptionDate: response.user != null ? response?.user?.createdAt : "",
    jwt: response.jwt != null ? response.jwt : "",
    auth0: user,
  };
  window.localStorage.setItem("wads_userProfile", JSON.stringify(userStorage));
  if (userStorage.subscriptionStatus == "subscribed") {
    let emailSuscription = {
      email: maskEmail(userStorage.email),
      picture: userStorage.picture,
      type: userStorage?.id?.split("|")?.[0] ?? "auth0",
    };
    window.localStorage.setItem("email_suscription", JSON.stringify(emailSuscription));
  }
};

export const setToken = (token, time = "") => {
  let  timeCookie = time ? parseInt(time) : 24;
  let expDate = getExpireDate(timeCookie);
  document.cookie =`__token_auth0=${token}; expires=${expDate.toUTCString()}; path=/`;
};

export const getExpireDate = (expire) => {
  let expDate = new Date();
  expDate.setHours(expDate.getHours() + expire);
  return expDate;
};

export const deleteCookie = (cookie) => {
  document.cookie = cookie +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export const getSubscriptionStatus = (user) => {
    if(!user)
        return "0";
    return (user.subscriptionStatus == "subscribed") ? "2" : "1";
}

export const getAge = (dateString) => {
  if(!dateString){
      return "";
  }
  const today = new Date();
  const birthDate = new Date(dateString);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
  }
  return age;
}

export const getUserJwt = () => {
  let userProfile = getUserProfile();
  if (userProfile && userProfile?.jwt) {
    return userProfile?.jwt;
  }
  return null;
};

export const getUserID= () => {
  let userProfile = getUserProfile();
  if (userProfile && userProfile?.id) {
    return userProfile?.id;
  }
  return null;
};

export const setCookieSuscription = (suscription, time = "") => {
  let  timeCookie = time ? parseInt(time) : 24;
  let expDate = getExpireDate(timeCookie);
  document.cookie = `statusSus=${suscription}; expires=${expDate.toUTCString()}; path=/`;
};